import type { CoralConfig } from "@voxmedia/duet-context/context/config-context";

if (
  !process.env.NEXT_PUBLIC_CORAL_ORIGIN ||
  !process.env.NEXT_PUBLIC_CORAL_MODERATION_EMAIL ||
  !process.env.NEXT_PUBLIC_CORAL_NAME_PREFIX
) {
  throw new Error("Missing environment variables");
}

export const CORAL_CACHE_FINGERPRINT =
  process.env.NEXT_PUBLIC_CORAL_CACHE_FINGERPRINT || "0";
export const CORAL_ORIGIN: string = process.env.NEXT_PUBLIC_CORAL_ORIGIN;
export const CORAL_MODERATION_EMAIL: string =
  process.env.NEXT_PUBLIC_CORAL_MODERATION_EMAIL;
export const CORAL_NAME_PREFIX: string =
  process.env.NEXT_PUBLIC_CORAL_NAME_PREFIX;
export const CORAL_SITE_ID = process.env.NEXT_PUBLIC_CORAL_SITE_ID || "";

// Coral API
export const CORAL_GRAPHQL_API_URL = CORAL_ORIGIN
  ? new URL("/api/graphql", CORAL_ORIGIN).toString()
  : "";

export const CORAL_COUNTS_API_URL = CORAL_ORIGIN
  ? new URL("/api/story/counts/v2", CORAL_ORIGIN).toString()
  : "";

// Config used for Config/UI Context
export const coralConfig: CoralConfig = {
  commentRecThreshold: 5,
  commentCalloutThreshold: 75,
  enableLegacyID: process.env.NEXT_PUBLIC_CORAL_LEGACY_ID === "true",
  namePrefix: CORAL_NAME_PREFIX,
  cacheFingerprint: CORAL_CACHE_FINGERPRINT,
  origin: CORAL_ORIGIN,
  moderationEmail: CORAL_MODERATION_EMAIL,
  siteId: CORAL_SITE_ID,
};
